import { debouncedHandleResize, TsDOM as q } from '@/scripts/core/TsDOM'
import { initializeScrollAnimationTrigger } from '@/scripts/theme/animations'
import {
	setCustomerCategory,
	updateFromCartCategoryCookie,
} from '@/scripts/interactive-defer/cart-functions'
import {
	focusVisiblePolyfill,
	initializeSummaryA11y,
} from '@/scripts/core/global'
import { WaitlistPopup } from '@/scripts/interactive-defer/welcome-popup'
export function formatPhoneNumber(unchecked_number: string) {
	let phone_number = unchecked_number
		.replace('(', '')
		.replace(')', '')
		.replace('+', '')
		.replaceAll('-', '')
		.replaceAll(' ', '')
		.trim()
	phone_number = `+1${phone_number}`
	return phone_number
}

export function openWaitlistModal(
	url: string,
	variantId: number,
	opener: HTMLElement
) {
	const modal = q.rs<WaitlistPopup>(`waitlist-popup`)
	void modal.openPopup(url, variantId, opener)
}

function setupInputFocusWorkaround() {
	document.addEventListener('DOMContentLoaded', function () {
		const viewport = q.rs('meta[name=viewport]')

		function adjustViewport(zoomEnabled: boolean) {
			const scaleSettings = zoomEnabled
				? '1.0, user-scalable=1'
				: '1.0, user-scalable=0'
			viewport.setAttribute(
				'content',
				`width=device-width, initial-scale=1.0, maximum-scale=${scaleSettings}`
			)
		}

		document.addEventListener(
			'focusin',
			function (event) {
				const target = q.ot(event)
				if (!target) return
				if (
					target.tagName === 'INPUT' ||
					target.tagName === 'SELECT' ||
					target.tagName === 'TEXTAREA'
				) {
					adjustViewport(false)
				}
			},
			true
		)
		document.addEventListener(
			'focusout',
			function (event) {
				const target = q.ot(event)
				if (!target) return
				if (
					target.tagName === 'INPUT' ||
					target.tagName === 'SELECT' ||
					target.tagName === 'TEXTAREA'
				) {
					adjustViewport(false)
				}
			},
			true
		)

		document.addEventListener(
			'blur',
			function (event) {
				const target = q.ot(event)
				if (!target) return
				if (
					target.tagName === 'INPUT' ||
					target.tagName === 'SELECT' ||
					target.tagName === 'TEXTAREA'
				) {
					adjustViewport(true)
				}
			},
			true
		)
	})
}
export function deferredGlobalSetup() {
	initializeSummaryA11y()
	try {
		document.querySelector(':focus-visible')
	} catch (e) {
		focusVisiblePolyfill()
	}
	// mediaLoader
	window.addEventListener('DOMContentLoaded', () =>
		initializeScrollAnimationTrigger()
	)

	document.addEventListener('shopify:section:load', (event: Event) => {
		initializeScrollAnimationTrigger(q.rt<Event, Document>(event))
	})
	setupInputFocusWorkaround()
	q.setupScrollAnchors()
	window.addEventListener('resize', debouncedHandleResize)
	setCustomerCategory()
	updateFromCartCategoryCookie()
}
